import { useMotionValue, useTransform } from "framer-motion";
import { useCallback } from "react";
import { SWIPE_THRESHOLD, SwipeDirection } from "@/constants/swipeConstants";

type SwipeGestureOptions = {
  onSwipe: (direction: SwipeDirection) => void;
  threshold?: number;
};

export const useSwipeGesture = ({ onSwipe, threshold = SWIPE_THRESHOLD }: SwipeGestureOptions) => {
  const x = useMotionValue(0);
  const rotate = useTransform(x, [-200, 0, 200], [-5, 0, 5]);

  // 右スワイプの設定
  const rightOpacity = useTransform(x, [50, 0], [1, 0]);
  const rightScale = useTransform(x, [50, 0], [1, 0.8]);

  // 左スワイプの設定
  const leftOpacity = useTransform(x, [0, -50], [0, 1]);
  const leftScale = useTransform(x, [0, -50], [0.8, 1]);

  const handleDragEnd = useCallback(
    (_e: any, info: any) => {
      console.log("Drag ended", info.offset.x);
      if (info.offset.x > threshold) {
        onSwipe("right");
      } else if (info.offset.x < -threshold) {
        onSwipe("left");
      }
    },
    [onSwipe, threshold]
  );

  return {
    x,
    rotate,
    rightOpacity,
    rightScale,
    leftOpacity,
    leftScale,
    handleDragEnd
  };
};
